import config from '../config';
import SoundManager from '../utils/SoundManager';
import {Howl, Howler} from '../utils/Howler';

const LOADER_BAR_WIDTH = 144;

class Preload extends Phaser.Scene {
  init () {
    // console.log('Preload.init');
    let g = this;

    g.add.sprite(config.CENTER_X, config.CENTER_Y, 'intro-bg');
    let cyborg = g.add.sprite(config.CENTER_X + 200, config.CENTER_Y + 250, 'loader-cyborg');
    // cyborg.setScale(0.8);
    let texture = g.add.sprite(config.CENTER_X, config.HEIGHT, 'loader-texture');
    texture.setOrigin(0.5, 1);
    let bb = g.add.sprite(config.CENTER_X - 200, config.CENTER_Y - 80, 'loader-bb');
    // bb.setScale(0.8);
    let logo = g.add.sprite(config.CENTER_X, config.HEIGHT - 350, 'loader-logo');
    logo.setScale(0.8);
    let bar = g.add.sprite(config.CENTER_X, config.HEIGHT - 150, 'loader-bar');
    bar.setScale(0.8);

    let loaderBar = g.add.graphics();
    this.graphics = { loaderBar };

    g.sys.game.dataManager.setSessionItem(config.BASE_SCENE, 'Preload');
    
    this.assetLoadProgress = 0;
    this.audioLoadProgress = 0;
    this.audioLoadCount = 0;
    this.audioLoadTotal = 0;
    
    this.finished = false;

    g.load.on('progress', g.onLoadProgress, g);
  }

  onLoadProgress (progress) {
    this.assetLoadProgress = progress;
    this.updateLoadingBar();
  }
  
  updateLoadingBar(){
    let { loaderBar } = this.graphics;
    loaderBar.clear();
    loaderBar.fillStyle(0x5ef040, 1);
    var progress = (this.assetLoadProgress * 0.75) + (this.audioLoadProgress * 0.25);
    loaderBar.fillRoundedRect(config.CENTER_X - 71, config.HEIGHT - 155, LOADER_BAR_WIDTH * progress, 7, 4);
  }

  preload () {
    let g = this;

    g.LoadAudioFiles();

    g.load.path = config.MEDIA_MAPS_PATH;
    g.load.json('map-0', 'map-0.json');
    g.load.json('map-1', 'map-1.json');
    g.load.json('map-2', 'map-2.json');
    g.load.json('map-3', 'map-3.json');
    g.load.json('map-4', 'map-4.json');
    g.load.json('map-5', 'map-5.json');
    g.load.json('map-6', 'map-6.json');
    g.load.json('map-7', 'map-7.json');
    g.load.json('map-8', 'map-8.json');
    g.load.json('map-9', 'map-9.json');
    g.load.json('map-10', 'map-10.json');
    g.load.json('map-11', 'map-11.json');
    g.load.json('map-12', 'map-12.json');
    g.load.json('map-13', 'map-13.json');
    g.load.json('map-14', 'map-14.json');
    g.load.json('map-15', 'map-15.json');
    g.load.json('map-16', 'map-16.json');
    g.load.json('map-17', 'map-17.json');
    g.load.json('map-18', 'map-18.json');
    g.load.json('map-19', 'map-19.json');
    g.load.json('map-20', 'map-20.json');
    g.load.json('map-21', 'map-21.json');
    g.load.json('map-22', 'map-22.json');
    g.load.json('map-23', 'map-23.json');
    g.load.json('map-24', 'map-24.json');
    g.load.json('map-25', 'map-25.json');
    g.load.json('map-26', 'map-26.json');
    // g.load.json('map-example', 'map-example.json');
    // g.load.json('map-antacid', 'powerups/map-antacid.json');
    // g.load.json('map-armor', 'powerups/map-armor.json');
    // g.load.json('map-booster', 'powerups/map-booster.json');
    // g.load.json('map-magnet', 'powerups/map-magnet.json');

    //   // Load Assets for the preloader screen
    g.load.path = config.MEDIA_IMAGE_PATH;

    g.load.atlas('intro-body', 'intro/body.png', 'intro/body.json');
    g.load.atlas('intro-legs', 'intro/legs.png', 'intro/legs.json');
    g.load.image('intro-bolt-left', 'intro/bolt-left.png');
    g.load.image('intro-bolt-right', 'intro/bolt-right.png');
    g.load.image('intro-cyborg-full', 'intro/cyborg-full.png');
    g.load.image('brand-logo', 'intro/logos/brand_logo.png');
    g.load.image('cn-logo', 'intro/logos/cn_logo.png');
    g.load.image('intro-logo', 'intro/logos/logo_' + g.game.gameConfig.language + '.png');
    g.load.image('intro-play-btn', 'intro/play-btn.png');
    g.load.image('intro-vortext', 'intro/vortext.png');

    g.load.image('overlay-bg', 'overlay-bg.jpg');
    g.load.atlas('continue-sprite', 'continue/sprite.png', 'continue/sprite.json');
    g.load.atlas('continue-head', 'continue/head.png', 'continue/head.json');
    g.load.atlas('continue-wing', 'continue/wings.png', 'continue/wings.json');
    g.load.atlas('score-sprite', 'score/sprite.png', 'score/sprite.json');
    g.load.atlas('score-eyes', 'score/eyes.png', 'score/eyes.json');
    g.load.atlas('settings-sprite', 'settings/sprite.png', 'settings/sprite.json');
    g.load.atlas('settings-bb', 'settings/bb.png', 'settings/bb.json');
    g.load.atlas('store-sprite', 'store/sprite.png', 'store/sprite.json');

    g.load.atlas('tilesheet', 'play/tilesheet2x.png', 'play/tilesheet2x.json');
    g.load.atlas('powerup-icons', 'play/powerup-icons.png', 'play/powerup-icons.json');
    g.load.atlas('bubbles', 'play/bubbles.png', 'play/bubbles.json');
    g.load.atlas('magnet-animation', 'play/magnet-animation.png', 'play/magnet-animation.json');
    g.load.atlas('coin', 'play/coin.png', 'play/coin.json');
    g.load.atlas('booster-effect', 'play/booster-effect.png', 'play/booster-effect.json');
    g.load.atlas('x2-bounce', 'play/x2-bounce.png', 'play/x2-bounce.json');
    g.load.atlas('wall-charge', 'play/wall-charge2x.png', 'play/wall-charge2x.json');
    g.load.atlas('bumblebee', 'play/bumblebee.png', 'play/bumblebee.json');
    g.load.atlas('bumblebee-trail', 'play/trail.png', 'play/trail.json');
    g.load.atlas('bee-money', 'play/bee-money.png', 'play/bee-money.json');
    g.load.atlas('armor-burst', 'play/armor-burst.png', 'play/armor-burst.json');
    g.load.atlas('gate-block', 'play/gate-block.png', 'play/gate-block.json');
    g.load.atlas('warp-spin', 'play/warp-spin.png', 'play/warp-spin.json');
    g.load.atlas('warp-enter-exit', 'play/warp-enter-exit.png', 'play/warp-enter-exit.json');
    g.load.image('bumblebee-glow', 'play/bumblebee-glow.png');
    g.load.image('htp-text', 'play/htp-text.png');
    g.load.image('bile-top', 'play/bile/top.png');
    g.load.image('bile-fill', 'play/bile/fill.png');
    g.load.image('tubes', 'play/tubes.png');

    g.load.image('bg-black', 'play/background/bg-blackout.jpg');
    g.load.image('bg-blue', 'play/background/bg-blue.jpg');
    g.load.image('bg-gold', 'play/background/bg-gold.jpg');
    g.load.image('bg-green', 'play/background/bg-green.jpg');
    g.load.image('bg-orange', 'play/background/bg-orange.jpg');
    g.load.image('bg-pink', 'play/background/bg-pink.jpg');
    g.load.image('bg-purple', 'play/background/bg-purple.jpg');
    g.load.image('bg-red', 'play/background/bg-red.jpg');

    g.load.atlas('nanite-expander', 'play/nanite-expander2x.png', 'play/nanite-expander2x.json');
    g.load.atlas('electric-spikes', 'play/electric-spikes2x.png', 'play/electric-spikes2x.json');
    g.load.atlas('bumper', 'play/bumper.png', 'play/bumper.json');
    g.load.atlas('zap', 'play/zap.png', 'play/zap.json');
    g.load.atlas('cake-particles', 'particles.png', 'particles.json');
    
    //Webfont
    g.load.rexWebFont('webfont', {
      "key": "fredburger_black",
      "type": "rexWebFont",
      custom:{
        "families": ["FredBurger Black"],
        "urls": [config.MEDIA_FONTS_PATH + (g.sys.game.gameConfig.language == "ar" ? "fredburger_arabic.css" : "fredburger.css")]
      }
    });

  }

  create () {
    // console.log('Preload.create');
    let g = this;

    let frames;
    // wall charge frames
    frames = g.anims.generateFrameNames('wall-charge', {
      prefix: 'electric-wall-single-',
      start: 0,
      end: 53,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'wall-charge-single',
      frames: frames
    });
    frames = g.anims.generateFrameNames('wall-charge', {
      prefix: 'electric-wall-end-',
      start: 0,
      end: 53,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'wall-charge-end',
      frames: frames
    });
    frames = g.anims.generateFrameNames('wall-charge', {
      prefix: 'electric-wall-mid-',
      start: 0,
      end: 53,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'wall-charge-mid',
      frames: frames
    });
    // electric spikes
    frames = g.anims.generateFrameNames('electric-spikes', {
      prefix: 'straight-electric-spike-',
      start: 0,
      end: 39,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'electric-spikes-mid',
      frames: frames,
      showOnStart: true,
      hideOnComplete: true
    });
    frames = g.anims.generateFrameNames('electric-spikes', {
      prefix: 'corner-electric-spike-',
      start: 0,
      end: 39,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'electric-spikes-end',
      frames: frames,
      showOnStart: true,
      hideOnComplete: true
    });
    // start bumblebee
    frames = g.anims.generateFrameNames('bumblebee');
    g.anims.create({
      key: 'bumblebee-down',
      frames: frames.slice(8, 10),
      repeat: -1
    });
    g.anims.create({
      key: 'bumblebee-hover',
      frames: frames.slice(10, 12),
      repeat: -1
    });
    g.anims.create({
      key: 'bumblebee-side',
      frames: frames.slice(12, 14),
      repeat: -1
    });
    g.anims.create({
      key: 'bumblebee-death',
      frames: frames.slice(14, 16),
      repeat: -1
    });
    g.anims.create({
      key: 'bumblebee-up',
      frames: frames.slice(16, 18),
      repeat: -1
    });
    g.anims.create({
      key: 'armor-bumblebee-down',
      frames: frames.slice(0, 2),
      repeat: -1
    });
    g.anims.create({
      key: 'armor-bumblebee-hover',
      frames: frames.slice(2, 4),
      repeat: -1
    });
    g.anims.create({
      key: 'armor-bumblebee-side',
      frames: frames.slice(4, 6),
      repeat: -1
    });
    g.anims.create({
      key: 'armor-bumblebee-up',
      frames: frames.slice(6, 8),
      repeat: -1
    });
    // start zap
    frames = g.anims.generateFrameNames('zap');
    g.anims.create({
      key: 'wall-zap',
      frames: frames,
      repeat: -1,
      showOnStart: true,
      delay: 0
    });
    frames = g.anims.generateFrameNames('nanite-expander', {
      prefix: 'nanite-entender_',
      start: 0,
      end: 22,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'nanite-expander-open',
      frames: frames
    });
    frames = g.anims.generateFrameNames('nanite-expander', {
      prefix: 'nanite-entender_',
      start: 23,
      end: 28,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'nanite-expander-rotate',
      frames: frames,
      repeat: config.EXPANDERS_ROTATE_COUNT
    });
    frames = g.anims.generateFrameNames('nanite-expander', {
      prefix: 'nanite-entender_',
      start: 95,
      end: 111,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'nanite-expander-close',
      frames: frames
    });
    frames = g.anims.generateFrameNames('bumper');
    g.anims.create({
      key: 'bump',
      frames: frames
    });
    frames = g.anims.generateFrameNames('bumblebee-trail');
    g.anims.create({
      key: 'trail-reveal',
      frames: frames
    });
    frames = g.anims.generateFrameNames('armor-burst');
    g.anims.create({
      key: 'armor-burst',
      frames: frames
    });
    frames = g.anims.generateFrameNames('gate-block');
    g.anims.create({
      key: 'gate-block',
      frames: frames
    });
    frames = g.anims.generateFrameNames('bubbles');
    g.anims.create({
      key: 'bubbling',
      frames: frames,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('magnet-animation');
    g.anims.create({
      key: 'magnet-animation',
      frames: frames,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('booster-effect');
    g.anims.create({
      key: 'booster-effect',
      frames: frames,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('x2-bounce');
    g.anims.create({
      key: 'x2-bounce',
      frames: frames,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('coin', {
      prefix: 'coin-frame',
      start: 1,
      end: 7,
      suffix: '.png'
    });
    g.anims.create({
      key: 'coin-spin',
      frames: frames,
      repeat: -1,
      frameRate: 12
    });
    frames = g.anims.generateFrameNames('warp-spin');
    g.anims.create({
      key: 'warp-spin',
      frames: frames,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('warp-enter-exit');
    g.anims.create({
      key: 'warp-enter-exit',
      frames: frames,
      showOnStart: true,
      hideOnComplete: true
    });
    frames = g.anims.generateFrameNames('score-eyes');
    g.anims.create({
      key: 'score-eyes',
      frames: frames,
      repeat: -1,
      repeatDelay: 1000
    });
    frames = g.anims.generateFrameNames('continue-head');
    g.anims.create({
      key: 'continue-head',
      frames: frames
    });
    frames = g.anims.generateFrameNames('continue-wing');
    g.anims.create({
      key: 'continue-wing',
      frames: frames
    });
    // start settings bb
    frames = g.anims.generateFrameNames('settings-bb', {
      prefix: 'arm/arm down/arm_',
      start: 108,
      end: 150,
      suffix: '.png',
      zeroPad: 3
    });
    g.anims.create({
      key: 'settings-arm-down',
      frames: frames
    });
    frames = g.anims.generateFrameNames('settings-bb', {
      prefix: 'arm/arm up/arm_',
      start: 0,
      end: 20,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'settings-arm-up',
      frames: frames
    });
    frames = g.anims.generateFrameNames('settings-bb', {
      prefix: 'arm/finger pick/arm_',
      start: 183,
      end: 229,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'settings-finger-pick',
      frames: frames
    });
    frames = g.anims.generateFrameNames('settings-bb', {
      prefix: 'arm/finger wiggle/arm_',
      start: 55,
      end: 89,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'settings-finger-wiggle',
      frames: frames
    });
    frames = g.anims.generateFrameNames('settings-bb', {
      prefix: 'eyes/eyes_',
      start: 30,
      end: 39,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'settings-eyes',
      frames: frames,
      repeat: -1,
      repeatDelay: 3000
    });
    frames = g.anims.generateFrameNames('settings-bb', {
      prefix: 'foot/foot_',
      start: 0,
      end: 20,
      suffix: '.png',
      zeroPad: 2
    });
    g.anims.create({
      key: 'settings-foot',
      frames: frames,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('intro-body');
    g.anims.create({
      key: 'intro-body',
      frames: frames,
      yoyo: true,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('intro-legs');
    g.anims.create({
      key: 'intro-legs',
      frames: frames,
      yoyo: true,
      repeat: -1
    });
    frames = g.anims.generateFrameNames('bee-money');
    g.anims.create({
      key: 'bee-money',
      frames: frames
    });
  }
  update () {
    if(this.sys.game.globalPauseActive) return;
    
    if(this.load.totalToLoad == 0){
			this.assetLoadProgress = 1;
    }
    
    this.updateLoadingBar();

    if (!this.finished && this.assetLoadProgress >= 1 && this.audioLoadProgress >= 1) {
      this.finished = true;
      this.scene.launch('SoundManager');
      this.scene.start('Intro');
    }
  }
  
  LoadAudioFiles(){
    var g = this;
    g.load.path = config.MEDIA_AUDIO_PATH;
    
    g.audioLoadProgress = 0;
    g.audioLoadCount = 0;
    g.audioLoadTotal = 0;
    
    // loops
    g.LoadAudio('loop-intro', 'loops/intro-loop.mp3');
    g.LoadAudio('loop-EASY', 'loops/game-easy.mp3');
    g.LoadAudio('loop-MEDIUM', 'loops/game-medium.mp3');
    g.LoadAudio('loop-HARD', 'loops/game-hard.mp3');
    g.LoadAudio('loop-INTERMISSION', 'loops/game-transition-loop.mp3');
    g.LoadAudio('loop-end', 'loops/end-loop.mp3');
    // sfx
    g.LoadAudio('armor-destroyed', 'sfx/armor-destroyed/armor-destroyed.mp3');
    g.LoadAudio('bread-crumb', 'sfx/bread-crumb/bread-crumb.mp3');
    g.LoadAudio('bumper', 'sfx/bumper/bumper.mp3');
    g.LoadAudio('btn-play', 'sfx/btn-play/btn-play.mp3');
    g.LoadAudio('btn-regular', 'sfx/btn-regular/btn-regular.mp3');
    g.LoadAudio('coin-collected', 'sfx/coin-collected/coin-collected.mp3');
    g.LoadAudio('electric-fence', 'sfx/electric-fence/electric-fence.mp3');
    g.LoadAudio('electric-wall', 'sfx/electric-wall/electric-wall.mp3');
    g.LoadAudio('array-gameover-splat-1', 'sfx/gameover-splat/gameover-splat1.mp3');
    g.LoadAudio('array-gameover-splat-2', 'sfx/gameover-splat/gameover-splat2.mp3');
    g.LoadAudio('array-gameover-splat-3', 'sfx/gameover-splat/gameover-splat3.mp3');
    g.LoadAudio('goo-swim', 'sfx/goo-swim/goo-swim.mp3');
    g.LoadAudio('array-move-swoosh-1', 'sfx/move-swoosh/move-swoosh1.mp3');
    g.LoadAudio('array-move-swoosh-2', 'sfx/move-swoosh/move-swoosh2.mp3');
    g.LoadAudio('bee-money', 'sfx/bee-collect/bee-collect2.mp3');
    g.LoadAudio('nanite-cycle', 'sfx/nanite-cycle/nanite-cycle.mp3');
    g.LoadAudio('portal-enter', 'sfx/portal-enter/portal-enter.mp3');
    g.LoadAudio('portal-exit', 'sfx/portal-exit/portal-exit.mp3');
    g.LoadAudio('powerup-enabled', 'sfx/powerup-enabled/powerup-enabled.mp3');
    g.LoadAudio('wall-fill', 'sfx/wall-fill/wall-fill.mp3');
    g.LoadAudio('vo-gameover-great', 'sfx/vo-gameover-great/vo-gameover-great.mp3');
    g.LoadAudio('vo-gameover-poor', 'sfx/vo-gameover-poor/vo-gameover-poor.mp3');
  }
  
  LoadAudio(key, url){    
    if(!SoundManager.cache[key]){
      url = this.load.path + url;
      this.audioLoadTotal++;
            
      SoundManager.cache[key] = { src: url };
      
      var howl = new Howl({
          src: url
      });
      howl.once('load', this.OnLoadedAudio.bind(this));
    }
  }
  
  OnLoadedAudio(){
    this.audioLoadCount++;
    this.audioLoadProgress = this.audioLoadCount / this.audioLoadTotal;
  }
}

export default Preload;
